import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CONTEXT_TYPE, Order } from 'src/app/models/order.model';
import { ModalController } from '@ionic/angular';
import { CoreService } from 'src/app/api/core/core/core.service';
import { PrinterService } from 'src/app/api/core/printer/printer.service';

import * as moment from 'moment-timezone';
import { UtilityClass } from 'src/app/api/utils/UtilityClass';

@Component({
  selector: 'hub-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoComponent implements OnInit {
  @Input() order: Order;

  /** The customer name to display. Only shows for single order. */
  public customerName: string;

  /** The fulfillment specific details */
  public fulfillmentSummary: string;

  /** The string representation of the order time */
  public orderTimeStr: string;

  /** The string representation of the request time */
  public requestedTimeStr: string;

  /** The string representation of the ETA */
  public etaStr: string;

  /** The payment gateway icon */
  public paymentIconSrc: string;

  public etaBtnLabel: string = 'Set ETA';

  constructor(
    public modalCtrl: ModalController,
    public core: CoreService,
    public printer: PrinterService,
    public changeRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (this.order) {
      this.customerName = `${this.order.customer.first_name} ${this.order.customer.last_name || ''}`;
      this.orderTimeStr = moment(this.order.created_time).format('dddd MMMM D, h:mmA');
      this.requestedTimeStr = this.isASAP() ? 'ASAP' : moment(this.order.requested_time).format('dddd MMMM D, h:mmA');

      if (this.order.eta) {
        if (this.order.is_delivery_window) {
          this.etaStr = `${moment(this.order.requested_time).format('dddd MMMM D, h:mmA')} - ${moment(
            this.order.requested_time_end,
          ).format('h:mmA')}`;
        } else {
          this.etaStr = moment(this.order.eta).format('dddd MMMM D, h:mmA');
        }
      } else {
        this.etaStr = '';
      }

      if (this.order.payment_method.indexOf('google') === -1) {
        this.paymentIconSrc = `assets/images/gateways/icon_${this.order.payment_method}.png`;
      } else {
        this.paymentIconSrc = 'assets/images/gateways/icon_google_pay.svg';
      }

      switch (this.order.context_type) {
        case CONTEXT_TYPE.Delivery:
          const customerAddr = this.order.customer.address;
          this.fulfillmentSummary = `${customerAddr.unit_no ? customerAddr.unit_no + ' / ' : ''} ${
            customerAddr.street_no
          } ${customerAddr.address1} ${customerAddr.address2}<br/>${customerAddr.suburb} ${customerAddr.state} ${
            customerAddr.postcode
          }`;
          break;
        case CONTEXT_TYPE.Pickup:
          // no summary
          break;
        case CONTEXT_TYPE.Dine_in:
          this.fulfillmentSummary = 'TABLE: ' + this.order.getTableLabel();
          this.etaBtnLabel = 'Confirm';
          break;
        case CONTEXT_TYPE.Room_service:
          this.fulfillmentSummary = 'ROOM: ' + this.order.room_number;
          break;
        case CONTEXT_TYPE.Drive_up:
          this.fulfillmentSummary = `REGO: ${this.order.car_rego}<br/>COLOUR: ${this.order.car_colour}`;
          break;
      }
    } else {
      this.close(false);
    }
  }

  /** Compare Requested Time & Created time to see if is "ASAP" */
  isASAP(): boolean {
    //get difference between requested and created.
    const req_time = UtilityClass.parseTimeToTimezone(this.order.requested_time, this.core.Timezone);

    const create_time = UtilityClass.parseTimeToTimezone(this.order.created_time, this.core.Timezone);

    const diff = req_time.diff(create_time);

    //check if it is considered 'ASAP' = less than req_minutes_diff
    return diff < this.core.asap_required_time * 60000;
  }

  /** Closes the modal and open the eta selector */
  setEta(): void {
    this.close(false, true);
  }

  /** Closes the modal and prints the dockets */
  print(): void {
    this.close(true, false);
  }

  /** Close the modal */
  close(print: boolean = false, setEta: boolean = false): void {
    this.modalCtrl.dismiss({
      print: print,
      eta: setEta,
    });
  }
}
